import React from 'react';

function AuthReceiver() {

    return (
        <React.Fragment>
            <main className="app-page">
                <section className="app-page-content">
                    <div className="app-empty-state">
                        Return from login. Seems like a pointless page now.
                    </div>
                </section>
            </main>
        </React.Fragment>
    );
}

export default AuthReceiver;
